import { ROOT_URL } from 'gatsby-env-variables'
import Button from 'components/Button'
import ROUTES from 'Routes'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import { navigate } from 'gatsby'
import router from 'utils/router'
import analytics from '@mobi/libraries/analytics'
import { useIsInViewport } from 'hooks/useIsInViewport'
import { useEffect, useRef } from 'react'
import './LandingTestimonials.scss'
import storage, { handleStorageError } from 'utils/storage'
import { infoList, testimonials } from './constants'

const renderTestimonialDate = (date) => {
  if (!date) return <></>

  return new Date(date).toLocaleString().split(',')[0]
}

const LandingTestimonials = () => {
  const videoRef = useRef(null)

  const isVideoInViewport = useIsInViewport(videoRef)

  useEffect(() => {
    const hasViewedTestimonialVideo = handleStorageError(
      storage.session.getItem('hasViewedTestimonialVideo'),
      false
    )

    if (isVideoInViewport && !hasViewedTestimonialVideo) {
      storage.session.setItem('hasViewedTestimonialVideo', true)
      analytics.track('segmentElementViewed', 'VideoDepoimento')
    }
  }, [isVideoInViewport])

  const handleAccessibilityText = (text) => {
    const breakText = text.split(' ')
    const hasSmile = breakText.includes(';)')

    if (hasSmile) {
      const index = breakText.indexOf(';)')
      breakText[index] = '<span aria-hidden="true">;)</span>'
      return breakText.join(' ')
    }

    return text
  }

  return (
    <section className="landing-testimonials">
      <div className="landing-testimonials__container">
        <div className="landing-testimonials__header">
          <h2
            className="landing-testimonials__title"
            dangerouslySetInnerHTML={{
              __html:
                'Há <strong>25 anos</strong><br /> ajudando pessoas a<br /> limpar o nome',
            }}
          />
          <p
            className="landing-testimonials__subtitle"
            dangerouslySetInnerHTML={{
              __html: 'A Recovery te ajuda a transformar dívidas em recomeços',
            }}
          />
          <ol className="landing-testimonials__list-steps">
            {infoList.map((item, index) => (
              <li
                key={index}
                className="landing-testimonials__list-steps-item"
                dangerouslySetInnerHTML={{
                  __html: handleAccessibilityText(item?.text),
                }}
              />
            ))}
          </ol>

          <Button
            className="button"
            onClick={() => {
              handlePerformanceMark(ROUTES.register.pageName)
              navigate(ROUTES.register.path, {
                state: {
                  source_url: location.href,
                  mp_uuid: router.getQueryString('mp_uuid'),
                },
              })
            }}
            data-unique="a2ed7ee6-7b02-4d10-9117-23a4279e9743"
            data-tracking-location="lp"
            data-tracking-position="lp-testimonials-button"
            data-tracking-actionoutcome="check_cpf"
            data-tracking-element="button"
            data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
          >
            Consultar CPF
          </Button>
        </div>

        <div className="landing-testimonials__container-video" ref={videoRef}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Jc6tTIdX12o"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </div>

        <ul className="landing-testimonials__list">
          {testimonials?.map((item, index) => (
            <li key={index} className="landing-testimonials__list-item">
              <span className="landing-testimonials__list-item-name">
                {item?.name}
              </span>
              <p className="landing-testimonials__list-item-testimonial">
                {item?.content}
              </p>
              <span className="landing-testimonials__list-item-date">
                {renderTestimonialDate(item?.date)}
              </span>
            </li>
          ))}
        </ul>

        <p
          className="landing-testimonials__support-text"
          dangerouslySetInnerHTML={{
            __html:
              'A Recovery te ajuda a transformar</br> dívidas em recomeços.',
          }}
        />

        <Button
          className="button"
          onClick={() => {
            handlePerformanceMark(ROUTES.register.pageName)
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          data-unique="d86b7bd4-09c2-4287-9bb4-89f95f9ea41e"
          data-tracking-location="lp"
          data-tracking-position="lp-testimonials-button"
          data-tracking-actionoutcome="check_cpf"
          data-tracking-element="button"
          data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
        >
          Consultar CPF
        </Button>
      </div>
    </section>
  )
}

export default LandingTestimonials
